import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import "./vee-validate";
import store from './store'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { sync } from 'vuex-router-sync'
import { RECAPTCHA_SITE_KEY } from './env.config'

Vue.config.productionTip = false
Vue.use(VueReCaptcha, { siteKey: RECAPTCHA_SITE_KEY })

sync(store, router)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
